export const blockIconsMapsDesignServices = (
	<span className='material-symbols-outlined'>design_services</span>
);
